import React from "react";
import styled from "styled-components";

import WP from "WP";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import ErrorBoundary from "partials/ErrorBoundary";
import Footer from "partials/Footer";

import Media from "css/Media";

class Summary extends React.Component {
  render() {
    return (
      <Wrapper>
        <Container grid>
          <TitleGridElement
            colStart={{ default: 1, m: 5 }}
            colEnd={{ default: 8, m: 20 }}
            rowStart={1}
            justify='center'
          >
            <h1>{WP.trans.orderSummaryTitle}</h1>
          </TitleGridElement>
          <DescriptionGridElement
            colStart={{ default: 1, m: 5 }}
            colEnd={{ default: 8, m: 20 }}
            rowStart={2}
            justify='center'
          >
            <p
              dangerouslySetInnerHTML={{
                __html:
                  WP.lang === "no"
                    ? WP.options.booking_success_message
                    : WP.options.booking_success_message_en,
              }}
            />
          </DescriptionGridElement>
          <GridElement
            colStart={{ default: 1, m: 3 }}
            colEnd={{ default: 8, m: 12 }}
            rowStart={3}
          >
            <DetailsGrid>
              <ConfirmationBoxGridElement
                colStart={{ default: 1, m: 1 }}
                colEnd={{ default: 8, m: 12 }}
                rowStart={1}
              >
                <span>{WP.trans.orderSummaryMessage}</span>
              </ConfirmationBoxGridElement>
              <BookingSummaryGridElement
                colStart={{ default: 1, m: 1 }}
                colEnd={{ default: 8, m: 12 }}
                rowStart={2}
              >
                Test
              </BookingSummaryGridElement>
            </DetailsGrid>
          </GridElement>
        </Container>
        <ErrorBoundary for='Footer'>
          <Footer />
        </ErrorBoundary>
      </Wrapper>
    );
  }
}

export default Summary;

const Wrapper = styled.section`
  padding: 134px 0 0;

  ${Media.greaterThan("s")`
        padding: 220px 0 0;
    `}

  ${Media.greaterThan("m")`
        padding: 260px 0 0;
    `}
`;

const TitleGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  h1 {
    ${(props) => props.theme.fonts.h2}
  }

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementM};
    `}
`;

const DescriptionGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.elementS};
  margin-bottom: ${(props) => props.theme.spacing.contentXL};

  p {
    ${(props) => props.theme.fonts.h3}
  }

  a {
    color: ${(props) => props.theme.colors.link};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  ${Media.greaterThan("s")`
    padding-bottom: ${(props) => props.theme.spacing.blockXS};
  `}
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.33fr) 1fr;

  ${Media.greaterThan("s")`
    grid-template-columns: repeat(5, 1fr .435fr) 1fr;
  `}
`;

const ConfirmationBoxGridElement = styled(GridElement)`
  background-color: ${(props) => props.theme.colors.button};
  color: ${(props) => props.theme.colors.negative};
  padding: 24px 38px;

  span {
    font-size: 14px;
    line-height: 23px;
  }

  ${Media.greaterThan("s")`
        padding: 18px 38px;
    `}
`;

const BookingSummaryGridElement = styled(GridElement)`
  padding: ${(props) => props.theme.spacing.contentXL} 0;

  h2 {
    font-size: 15px;
    line-height: 38px;
  }

  ${Media.greaterThan("s")`
        padding: ${(props) => props.theme.spacing.contentXL} 36px;
    `}
`;
